import React, { useEffect, useState } from "react";

export default function FloatingComment({ onComment }) {
  return (
    <div className="text-center" onClick={() => onComment()}>
      <i
        className={
          "far fa-comment fa-2x floating-button floating-comment text-white rounded-circle pt-2"
        }
      />
    </div>
  );
}
